"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _updateFieldLayout = _interopRequireDefault(require("./updateFieldLayout"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles() {
  return {
    root: {
      margin: 'auto',
      position: 'relative'
    }
  };
};

var FieldsOverlay = /*#__PURE__*/function (_Component) {
  _inherits(FieldsOverlay, _Component);

  var _super = _createSuper(FieldsOverlay);

  function FieldsOverlay() {
    var _this;

    _classCallCheck(this, FieldsOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getFilteredFields", function () {
      // Get the list of fields for the current document and page
      var _this$props = _this.props,
          currentDocument = _this$props.currentDocument,
          page = _this$props.page;
      var _currentDocument$fiel = currentDocument.fields,
          fields = _currentDocument$fiel === void 0 ? [] : _currentDocument$fiel; // Filtered Field which are found in new page or
      // radio group fields from different page have group items in new page.

      return fields.filter(function (_ref) {
        var fieldPage = _ref.page,
            radioPages = _ref.radioGroupPages;
        return fieldPage === page || !!radioPages && radioPages.includes(page);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFields", function () {
      var _this$props2 = _this.props,
          currentDocument = _this$props2.currentDocument,
          zoom = _this$props2.zoom,
          renderField = _this$props2.renderField,
          page = _this$props2.page;
      var height = currentDocument.height,
          width = currentDocument.width;

      var filteredFields = _this.getFilteredFields();

      return filteredFields.map(function (field) {
        // Set field page to current page. This will help to find radioGroupItems
        // when they are split between multiple pages even though main field
        // is present in first page.
        field = _objectSpread(_objectSpread({}, field), {}, {
          page: page
        });
        var pageDimensions = {
          originalDimensions: {
            height: height,
            width: width
          },
          updatedDimensions: {
            height: height * zoom,
            width: width * zoom
          }
        };

        var fieldParams = _objectSpread(_objectSpread({}, field), (0, _updateFieldLayout.default)(pageDimensions, field));

        return renderField(fieldParams);
      });
    });

    return _this;
  }

  _createClass(FieldsOverlay, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          classes = _this$props3.classes,
          zoom = _this$props3.zoom,
          currentDocument = _this$props3.currentDocument,
          className = _this$props3.className;
      var height = currentDocument.height,
          width = currentDocument.width;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        style: {
          height: height * zoom,
          width: width * zoom,
          marginTop: -(height * zoom)
        }
      }, this.renderFields());
    }
  }]);

  return FieldsOverlay;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(FieldsOverlay);

exports.default = _default;